export type BadgeClass = typeof BadgeClass[keyof typeof BadgeClass];

export const BadgeClass = {
    None: '',
    Acknowledged: 'acknowledged',
    Approved: 'approved',
    AwaitingAcknowledgement: 'awaiting-acknowledgement',
    AwaitingAssignment: 'awaiting-assignment',
    AwaitingDecision: 'awaiting-decision',
    AwaitingFollowUp: 'awaiting-followup',
    AwaitingFurtherDetails: 'awaiting-further-details',
    Cancelled: 'cancelled',
    Declined: 'declined',
    MissingClinicalHistory: 'missing-clinical-history',
    MissingDocumentation: 'missing-documentation',
    MissingImages: 'missing-images',
    MissingPriorReport: 'missing-prior-report',
    ReviewOrderDetails: 'review-order-details',
    MissingPriorImages: 'missing-prior-images',
    ReadyToReport: 'ready-to-report',
    Reporting: 'reporting',
    Reported: 'reported',
    ReviewReferralDetails: 'review-referral-details',
    Stroke: 'stroke',
    Trauma: 'polytrauma',
    TransferringImages: 'transferring-images',
    ClinicalDiscussionRequired: 'clinical-discussion-required',
    Deferred: 'deferred'
};

export const SortedBadges = [
    // First Priority
    BadgeClass.Stroke,
    BadgeClass.Trauma,
    // Second Priority
    BadgeClass.MissingClinicalHistory,
    BadgeClass.MissingDocumentation,
    BadgeClass.MissingPriorReport,
    BadgeClass.MissingImages,
    BadgeClass.MissingPriorImages,
    BadgeClass.ReviewOrderDetails,
    BadgeClass.ReviewReferralDetails,
    BadgeClass.ClinicalDiscussionRequired,
    BadgeClass.AwaitingFollowUp,
    // Third Priority
    BadgeClass.Approved,
    BadgeClass.Declined,
    BadgeClass.Reported,
    BadgeClass.Cancelled,
    // Fourth Priority
    BadgeClass.ReadyToReport,
    BadgeClass.Reporting,
    BadgeClass.TransferringImages,
    BadgeClass.AwaitingFurtherDetails,
    BadgeClass.AwaitingAssignment,
    BadgeClass.AwaitingDecision,
    BadgeClass.AwaitingAcknowledgement,
    BadgeClass.Acknowledged,
    BadgeClass.Deferred
];
